module.exports = __webpack_public_path__ + "assets/img/bg-ecb7b508.jpg";